import type { ProviderPriceListItemModel, ServiceProductModel } from '@models/types'

import usePriceListMatrixItem from '../../../../hooks/usePriceListMatrixItem'

import ItemRow from './ItemRow'

interface PriceListItemProps {
  providerPriceListItem: ProviderPriceListItemModel,
  serviceProduct: ServiceProductModel,
}

const PriceListItem = (props: PriceListItemProps) => {
  const { providerPriceListItem, serviceProduct } = props

  const { rows } = usePriceListMatrixItem({ providerPriceListItem })

  return (
    <table>
      <thead>
        <tr>
          <td style={{ width: 'calc(100% - 740px)' }}>{`QTY - ${providerPriceListItem.quantity}`}</td>
          <td style={{ textAlign: 'right', width: 500 }}>Option Prices</td>
          <td style={{ textAlign: 'right', width: 120 }}>Base Price</td>
          <td style={{ textAlign: 'right', width: 120 }}>Total</td>
        </tr>
      </thead>
      <tbody>
        {/*
         // @ts-expect-error TS2322 */}
        {rows.map(row => <ItemRow key={row.key} rowData={row} serviceProduct={serviceProduct} />)}
      </tbody>
    </table>

  )
}

export default PriceListItem
